import APIBundler, { BundledMethods } from './bundler'

export type APIServiceProps = BundledMethods

const APIService: APIServiceProps = {}

export const APIServiceInit = () => APIBundler(APIService)

export default APIService
